module.exports = __webpack_public_path__ + "img/Referenzen_Security6.c564df16.jpg";